import { render, staticRenderFns } from "./RiskItem.vue?vue&type=template&id=6a4b892d&scoped=true&"
import script from "./RiskItem.vue?vue&type=script&lang=js&"
export * from "./RiskItem.vue?vue&type=script&lang=js&"
import style0 from "./RiskItem.vue?vue&type=style&index=0&id=6a4b892d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4b892d",
  null
  
)

export default component.exports